module.exports = __webpack_public_path__ + "static/media/mainLogo.b7dd8bbe.png";